/* eslint-disable import/order */
import React, { useEffect, useState } from 'react';


import { Grid, Button, Box, Typography, Stack, IconButton, Container, Link, useMediaQuery, useTheme, Divider, Drawer } from '@mui/material';
import Iconify from '../Iconify';
import { ReactComponent as Jotaro } from '../../assets/logo/choptonticket-3.svg';
import logo from '../../assets/logo/logo2.png';
import { NavLink } from 'react-router-dom';
import CustomButton from '../CustomButton';
import LucideIcon from '../LucideIcon';



function AppHeader() {
  const [visible, setVisible] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Container maxWidth="xl">

      <div className="header">
        <div className="logo">
          <Box sx={{ width: 40, height: 40, borderRadius: '10px' }}>
            <a href="/">
              <img src={logo} alt="Logo" />
            </a>
          </Box>
        </div>
        {
          !isMobile ?
            <Stack direction={'row'} sx={{ width: '100%' }}>
              <Stack direction={'row'} spacing={4} sx={{ width: '100%' }} justifyContent={'center'} alignItems={'center'}>
                <Link underline="none" href="#work" ><Typography variant='body1' color='text.secondary' fontWeight={500} noWrap>Comment ca marche</Typography> </Link>
                <Link underline="none" href="#feature" > <Typography variant='body1' color='text.secondary' fontWeight={500}>Services</Typography> </Link>
                <Link underline="none" href="#pricing" ><Typography variant='body1' color='text.secondary' fontWeight={500}>Tarifs</Typography> </Link>
                <Link underline="none" href="#faq" ><Typography variant='body1' color='text.secondary' fontWeight={500}>FAQ</Typography> </Link>
              </Stack>
              <Stack direction={'row'} spacing={2}>
                <Button sx={{
                  color: 'text.primary',
                  backdropFilter: "blur(8px)", // flou
                  backgroundColor: "transparent", // transparent blanc
                  border: "1px solid rgba(255, 255, 255, 0.3)", // léger contour
                  // boxShadow: "0 4px 20px rgba(0,0,0,0.2)", // ombre moderne
                  borderRadius: "12px",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.63)",
                    color: 'text.primary',
                    bgcolor: '#f2f2f2',
                    border: "1px solid #f2f2f2", // léger contour
                    // transform: "scale(1.025)",
                  },
                }} href="/login" size="medium" variant="outlined" startIcon={<LucideIcon name='User' />}>
                  <Typography variant='body1' color='text.primary' fontWeight={500}>Connexion</Typography>
                </Button>
                <CustomButton type='primaire' buttonText='Commencer maintenant' size="large" href="/bo" />
              </Stack>
            </Stack>
            : <IconButton
              onClick={() => setIsMobileMenuOpen(true)}
              sx={{
                color: 'text.primary',
                backdropFilter: "blur(8px)", // flou
                backgroundColor: "transparent", // transparent blanc
                border: "1px solid rgba(255, 255, 255, 0.3)", // léger contour
                // boxShadow: "0 4px 20px rgba(0,0,0,0.2)", // ombre moderne
                borderRadius: "12px",
                transition: "all 0.3s ease",
                "&:hover": {
                  background: "rgba(255, 255, 255, 0.63)",
                  color: 'text.primary',
                  bgcolor: '#f2f2f2',
                  border: "1px solid #f2f2f2", // léger contour
                  // transform: "scale(1.025)",
                },
              }} size="large">
              <LucideIcon name='Menu' />
            </IconButton>

        }



      </div>
      <Drawer
        transitionDuration={0}
        anchor="top"
        open={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        PaperProps={{
          sx: {
            width: '100%',
            maxHeight: '70vh', // 👈 contrôle la hauteur ici

            p: 3,
          },
        }}
      >
        <Stack spacing={3}>

          {/* Header Drawer */}
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Box sx={{ width: 40, height: 40 }}>
              <img src={logo} alt="Logo" style={{ width: '100%' }} />
            </Box>
            <IconButton onClick={() => setIsMobileMenuOpen(false)}>
              <LucideIcon name="X" />
            </IconButton>
          </Stack>



          {/* Navigation */}
          <Stack spacing={2} paddingTop={2}>
            {[
              { label: 'Comment ça marche', href: '#work' },
              { label: 'Services', href: '#feature' },
              { label: 'Tarifs', href: '#pricing' },
              { label: 'FAQ', href: '#faq' },
            ].map((item) => (
              <Link
                key={item.label}
                href={item.href}
                underline="none"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <Typography fontSize={18} color='text.primary' fontWeight={500}>
                  {item.label}
                </Typography>
              </Link>
            ))}
          </Stack>

          {/* Actions */}
          <Stack spacing={1}>
            <Button sx={{
              color: 'text.primary',
              backdropFilter: "blur(8px)", // flou
              backgroundColor: "transparent", // transparent blanc
              border: "1px solid gainsboro", // léger contour
              // boxShadow: "0 4px 20px rgba(0,0,0,0.2)", // ombre moderne
              borderRadius: "12px",
              transition: "all 0.3s ease",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.63)",
                color: 'text.primary',
                bgcolor: '#f2f2f2',
                border: "1px solid gainsboro", // léger contour
                // transform: "scale(1.025)",
              },
            }} href="/login" size="large" variant="outlined" startIcon={<LucideIcon name='User' />}>
              <Typography variant='body1' color='text.primary' fontWeight={500}>Connexion</Typography>
            </Button>

            <CustomButton
              fullWidth
              type="primaire"
              buttonText="Commencer maintenant"
              href="/bo"
            />
          </Stack>

        </Stack>
      </Drawer>

    </Container>
  );
}

export default AppHeader;
